'use strict';

angular.module('shiftTraderApp')
  .service('PermissionSetsStore', ['$log', '$rootScope', 'Session', '$q', '$timeout', 'PermissionSets',
    function ($log, $rootScope, Session, $q, $timeout, PermissionSets) {
      var that = this;

      var records = {};
      var requestSucceeded = {};
      var queue = {};
      var requestInProgress = {};

      this.flush = function() {
        records = {};
        queue = {};
        requestSucceeded = {};
        requestInProgress = {};
      };

      $rootScope.$on('flushCaches', function() {
        that.flush();
      });

      function processQueue(orgId) {
        console.log('processQueue', orgId);
        while (queue[orgId].length > 0) {
          var req = queue[orgId].shift();

          if (req.type === 'get_set') {
            var record = _.find(records[req.organization_id], {id: req.permission_set_id});

            if (record) {
              req.deferred.resolve(record);
            } else {
              req.deferred.reject();
            }
          } else {
            req.deferred.resolve(records[req.organization_id]);
          }
        }
      }

      function getPermissionSetsForOrg(orgId) {
        console.log('getPermissionSetsForOrg',orgId);
        PermissionSets.getByOrgId(orgId)
          .then(function(sets) {
            records[orgId] = sets;
            processQueue(orgId);
            requestSucceeded[orgId] = true;
          }, function() {

          });
      }

      function startOrWaitOnRequest() {
        var orgIds = _.keys(queue);

        _.each(orgIds, function(orgId) {
          // we know that there is at least one queued record for each orgId
          if (!requestInProgress[orgId]) {
            getPermissionSetsForOrg(orgId);
            requestInProgress[orgId] = true;
          }
        });
      }

      function orgRepresented(orgId) {
        return _.has(records, orgId);
      }

      this.getRecordForId = function(permissionSetId, orgId) {
        var deferred = $q.defer();

        if (orgRepresented(orgId) || requestSucceeded[orgId]) {
          var record = _.find(records[orgId], {id: permissionSetId});

          if (record) {
            deferred.resolve(record);
          } else {
            deferred.reject();
          }
        } else {
          if (_.isUndefined(queue[orgId])) {
            queue[orgId] = [];
          }

          queue[orgId].push({
            type: 'get_set',
            permission_set_id: permissionSetId,
            organization_id: orgId,
            deferred: deferred
          });

          startOrWaitOnRequest();
        }

        return deferred.promise;
      };

      this.getRecordsForOrgId = function(orgId) {
        var deferred = $q.defer();

        if (orgRepresented(orgId) || requestSucceeded[orgId]) {
          deferred.resolve(records[orgId]);
        } else {
          if (_.isUndefined(queue[orgId])) {
            queue[orgId] = [];
          }

          queue[orgId].push({
            type: 'get_all',
            organization_id: orgId,
            deferred: deferred
          });

          startOrWaitOnRequest();
        }

        return deferred.promise;
      };


  }]);
